module.exports = __webpack_public_path__ + "img/tu03.be28cf16.png";